import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getPayslipList = (query, token) => {
    let qs = buildQuery(query);
        return axios.get(`${baseUrl}/getPayslip${qs}`, {
          headers: {
            authorization: token,
          },
        });
      };
      export const getPayslipEmpList = (query, token) => {
    let qs = buildQuery(query);
        return axios.get(`${baseUrl}/getEmpList${qs}`, {
          headers: {
            authorization: token,
          },
        });
      };
      export const getPayslipByid = (id, token) => {

            return axios.get(`${baseUrl}/getPayslipbyID/${id}`, {
              headers: {
                authorization: token,
              },
            });
          };
  
      export const insertPayslipData = (data, token) =>{
        return axios.post(
           `${baseUrl}/insertPayslip`,
           data,
           {
             headers: {
               authorization: token,
             },
           }
         );
       }

       export const getEmpPaySlipDefault= (id, token) => {

        return axios.get(`${baseUrl}/getEmpPayslipDefault/${id}`, {
          headers: {
            authorization: token,
          },
        });
      };

      
      export const deleteEmpPaySlipData= (id, token) => {

         return  axios.delete(`${baseUrl}/deletePayslip/${id}`, {
          headers: {
            authorization: token,
          },
        });
      };
 
      export const updateValidationStatus = (id,token) =>{
        return axios.put(
           `${baseUrl}/updateValidationStatus`,
           {
            id:id
           }
           ,{
             headers: {
               authorization: token,
             },
           }
         );
       }
       export const updatePayslip = (id,data, token) =>{
        return axios.put(
           `${baseUrl}/updatePayslip/${id}`,
           data,
           {
             headers: {
               authorization: token,
             },
           }
         );
       }
     